import React from "react";
import { Button, notification } from "antd";
import { useSelector, useDispatch } from "react-redux";
import ticketActions from "../../redux/ticket/actions";
import schedulesActions from "../../redux/schedules/actions";
import { dateStringToEpoch, decryptData } from "../../utils/utility";
import { t } from "i18next";

const BuyTicketButton = ({
  selectedSeat,
  personName,
  personEmail,
  personPhone,
  priceType,
  priceId,
  priceTwoWay,
  priceAmount,
  setCheckEmptyInput,
  errorEmail,
  setSelectedSeat,
  ticketName,
  selectedTwoWaySeat,
  setSelectedTwoWaySeat,
}) => {
  const dispatch = useDispatch();
  const [apiNotification, contextHolderNotification] =
    notification.useNotification();
  const { getSchedules, getSchedulesTwoWay } = schedulesActions;
  const {
    addTicketsToCart,
    reserveTicket,
    setTicketsExpired,
    reserveTwoWayTicket,
  } = ticketActions;
  const { companies, token } = useSelector((state) => state.mainReducer);
  const { schedules, schedulesId, schedulesTwoWay, schedulesTwoWayId } =
    useSelector((state) => state.schedulesReducer);
  const { checkoutTickets } = useSelector((state) => state.ticketReducer);
  const {
    destinationFrom,
    destinationTo,
    destinationDate,
    showTwoWayDateInput,
    destinationDateTwoWay,
  } = useSelector((state) => state.destinationReducer);

  const getExactSchedule = schedules?.find(
    (schedule) => schedule?.kursId === schedulesId
  );

  const getExactTwoWaySchedule = schedulesTwoWay?.find(
    (schedule) => schedule?.kursId === schedulesTwoWayId
  );

  const localStorageCart = decryptData(localStorage.getItem("cart")) || [];
  const reserveTicketObject = {
    forDate: getExactSchedule?.scheduleStart,
    kursId: getExactSchedule?.kursId,
    priceId: priceId,
    priceTypeId: priceType,
    forPerson: personName,
    phone: personPhone,
    email: personEmail,
    placeNumber: selectedSeat?.seatId,
    twoWay: false,
    fromCity: getExactSchedule?.fromCity,
    toCity: getExactSchedule?.toCity,
    price: priceAmount,
    sector: getExactSchedule?.sector,
    scheduleEnd: getExactSchedule?.scheduleEnd,
    scheduleStart: getExactSchedule?.scheduleStart,
    ticketName: ticketName,
  };

  const selectedPriceTwoWay = getExactTwoWaySchedule?.price?.find(
    (p) => p.name === ticketName
  );

  const reserveTwoWayTicketObject = {
    forPerson: personName,
    fromCity: getExactSchedule?.fromCity,
    toCity: getExactSchedule?.toCity,
    phone: personPhone,
    email: personEmail,
    priceTwoWay: priceTwoWay,
    firstDirection: {
      sector: getExactSchedule?.sector,
      forDate: getExactSchedule?.scheduleStart,
      kursId: getExactSchedule?.kursId,
      priceId: priceId,
      priceTypeId: priceType,
      placeNumber: selectedSeat?.seatId,
      scheduleEnd: getExactSchedule?.scheduleEnd,
      scheduleStart: getExactSchedule?.scheduleStart,
    },
    secondDirection: {
      sector: getExactTwoWaySchedule?.sector,
      forDate: getExactTwoWaySchedule?.scheduleStart,
      kursId: getExactTwoWaySchedule?.kursId,
      priceId: selectedPriceTwoWay?.id,
      priceTypeId: selectedPriceTwoWay?.typeId,
      placeNumber: selectedTwoWaySeat?.seatId,
      scheduleEnd: getExactTwoWaySchedule?.scheduleEnd,
      scheduleStart: getExactTwoWaySchedule?.scheduleStart,
    },
  };

  const fillEmptyInputsError = () => {
    apiNotification.warning({
      message: t("emptyInputs"),
      description: t("fillEmptyFields"),
      placement: "top",
      duration: 0,
    });
  };

  const addTicketToCart = async () => {
    setCheckEmptyInput(true);
    if (
      selectedSeat &&
      (showTwoWayDateInput ? selectedTwoWaySeat : true) &&
      personName &&
      !errorEmail &&
      personEmail &&
      personPhone &&
      priceType &&
      priceId
    ) {
      if (localStorageCart?.length === 0) {
        const expirationTime = new Date().getTime() + 5 * 60 * 1000;
        localStorage.setItem("ticketExpirationTime", expirationTime);
      }
      dispatch(addTicketsToCart([...checkoutTickets, reserveTicketObject]));

      setSelectedSeat(null);
      setSelectedTwoWaySeat(null);
      setCheckEmptyInput(false);
      if (showTwoWayDateInput) {
        dispatch(
          reserveTwoWayTicket(
            token,
            companies[0]?.id,
            reserveTwoWayTicketObject
          )
        );
      } else {
        dispatch(reserveTicket(token, companies[0]?.id, reserveTicketObject));
      }
      setTimeout(() => {
        dispatch(
          getSchedules(
            token,
            companies[0]?.id,
            destinationFrom,
            destinationTo,
            dateStringToEpoch(destinationDate.format("DD/MM/YYYY HH:mm"))
          )
        );
      }, 500);

      setTimeout(() => {
        dispatch(
          getSchedulesTwoWay(
            token,
            companies[0]?.id,
            destinationTo,
            destinationFrom,
            dateStringToEpoch(destinationDateTwoWay.format("DD/MM/YYYY HH:mm"))
          )
        );
      }, 500);
      dispatch(setTicketsExpired(false));
    } else {
      fillEmptyInputsError();
    }
  };

  return (
    <>
      {contextHolderNotification}
      <Button
        onClick={addTicketToCart}
        className="buy-ticket-button custom-button"
        size="large"
        type="primary"
      >
        <span className="remove-pointer-events">{t("addToCart")}</span>
      </Button>
    </>
  );
};

export default BuyTicketButton;
